import { createTheme } from '@mui/material/styles';
import { palette } from './tokens';

export function buildMuiTheme(mode = 'light') {
  const p = palette[mode] || palette.light;
  return createTheme({
    palette: {
      mode,
      primary: {
        main: palette.brand.teal,
        dark: palette.brand.tealDark,
        contrastText: '#ffffff',
      },
      secondary: {
        main: palette.brand.blue,
        contrastText: '#ffffff',
      },
      background: {
        default: p.bg,
        paper: p.surface,
      },
      text: {
        primary: p.ink,
        secondary: p.ink60,
      },
      divider: p.border,
    },
    typography: {
      fontFamily: '"DM Sans", "Inter", "Poppins", sans-serif',
      h1: { fontFamily: '"Sora", "Poppins", sans-serif' },
      h2: { fontFamily: '"Sora", "Poppins", sans-serif' },
      h3: { fontFamily: '"Sora", "Poppins", sans-serif' },
      h4: { fontFamily: '"Sora", "Poppins", sans-serif' },
      h5: { fontFamily: '"Sora", "Poppins", sans-serif' },
      h6: { fontFamily: '"Sora", "Poppins", sans-serif' },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: p.appbarBg,
            color: p.ink,
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: p.drawerBg,
            color: p.ink,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: p.cardBg,
            borderColor: p.border,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: p.surface,
            color: p.ink,
            borderColor: p.border,
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: p.cardBg,
            color: p.ink,
            borderColor: p.border,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: p.ink,
            transition: 'all 150ms ease',
            '&:hover': {
              backgroundColor: p.surface2,
            },
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            backgroundColor: p.cardBg,
            color: p.ink,
            borderColor: p.border,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: p.border,
          },
        },
      },
    },
  });
}
